import type { FC, ReactNode } from "react";
import { Container } from "@viagogo/core/ui";
import { useContent } from "src/shared/components/content";
import { LeagueLogoAndContent } from "src/website-apps/shared/components/LeagueLogoAndContent";
import { SHARING_ORIGINS } from "src/website-apps/shared/components/stubhub-sharing/SharingOrigins";
import {
  ButtonDiv,
  HeroHeaderSharingIcon,
  StyledContentWrapper,
  StyledHeroHeader,
  StyledSubtitle,
  StyledTitle,
} from "./styled-components";
import { ViewAllTeamsButton } from "./ViewAllTeamsButton";

interface Props {
  categoryId: number | undefined;
  leagueContent: ReactNode;
  logoUrl: string | null;
  onClick: () => void;
  title: string | undefined;
}

/**
 * Large Header Component w/ Background Image for Applicable CategoryGroupings
 * @see https://www.figma.com/file/Y9JIAqbF7ljecUFj4yAypS/General-Innovation-XPs---Master?node-id=303-2750&t=XoBKXQnmp7tJ91hz-4
 */
export const HeroHeader: FC<Props> = ({ categoryId, leagueContent, logoUrl, onClick, title }) => {
  const subtitleContent = useContent("cid$#3246920#"); // Experience the excitement live. Get your tickets today!
  const imageUrl = `https://media.stubhubstatic.com/stubhub-product/image/upload/q_auto:low/v1690302372/homepage/category-header-images/grouping-${categoryId}.png`;

  return (
    <StyledHeroHeader backgroundImageUrl={imageUrl} backgroundYPosition={categoryId === 4871 ? "top" : "center"}>
      <Container>
        <StyledContentWrapper>
          {logoUrl && <LeagueLogoAndContent leagueContent={leagueContent} logoUrl={logoUrl} />}
          <StyledTitle>{title}</StyledTitle>
          <StyledSubtitle>{subtitleContent}</StyledSubtitle>
          <ButtonDiv>
            <ViewAllTeamsButton onClick={onClick} />
            <HeroHeaderSharingIcon sharingOrigin={SHARING_ORIGINS.CATEGORY_GROUPING} data={{ title }} />
          </ButtonDiv>
        </StyledContentWrapper>
      </Container>
    </StyledHeroHeader>
  );
};
